<template>
  <div>
    <b-modal
      id="HiringModal"
      :visible="showHiringModal"
      size="xl"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @show="changeTabName"
      @hidden="closeModal"
    >
      <b-overlay :show="showSpinner">
        <div
          class="
            b-modal-header
            d-flex
            align-items-center
            justify-content-between
            px-4
            py-3
          "
        >
          <div>Select Hiring Process</div>
          <div class="rotate-on-hover" @click="closeModal">
            <img
              :style="showButtonLoader ? 'opacity:50%' : ''"
              src="../../../assets/panelist/blue_cross.svg"
              alt=""
              :class="!showButtonLoader ? 'pointer rotate-on-hover' : ''"
            />
          </div>
        </div>
        <hr class="m-0" />
        <div class="w-100 relativeclass px-4 py-2">
          <div class="newInt-control-tabs w-100">
            <b-tabs v-model="activeTab" content-class="mt-1 position-relative">
              <b-tab
                @click="
                  (tabName = 'interviewProcess'),
                    $refs.interviewProcessModal.resetMethod()
                "
              >
                <template #title>
                  <div class="d-flex align-items-center">
                    <div>Interview Process</div>
                    <img
                      v-if="interviewProcessExists"
                      class="ml-2"
                      src="../../../assets/new-createjobs/success-svg.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="ml-2"
                      src="../../../assets/new-createjobs/info-svg.svg"
                      alt=""
                    />
                  </div>
                </template>
                <div>
                  <InterviewProcessModal
                    ref="interviewProcessModal"
                    @handle-spinner="stopSpinner"
                    :interviewProcessID="interviewProcessID"
                    @update-disable-save="handleDisableSave"
                  />
                </div>
              </b-tab>
              <b-tab
                v-if="
                  roles.includes('GET_FEEDBACK_FORM') ||
                  roles.includes('VIEW_MANAGER')
                "
                @click="
                  tabName = 'feedbackForm';
                  $refs.feedbackFormModal.resetMethod();
                "
              >
                <template #title>
                  <div class="d-flex align-items-center">
                    <div>Feedback Form</div>
                    <img
                      v-if="feedbackFormExists"
                      class="ml-2"
                      src="../../../assets/new-createjobs/success-svg.svg"
                      alt=""
                    />
                    <img
                      v-else
                      class="ml-2"
                      src="../../../assets/new-createjobs/info-svg.svg"
                      alt=""
                    />
                  </div>
                </template>
                <div>
                  <FeedbackFormModal
                    ref="feedbackFormModal"
                    @update-disable-save="handleDisableSave"
                    :feedbackFormID="feedbackFormID"
                  />
                </div>
              </b-tab>
            </b-tabs>
          </div>
          <div
            class="set-button bluebtn"
            @click="goToHiring"
            v-if="
              (roles.includes('PUSH_FEEDBACK_FORM') &&
                tabName == 'feedbackForm') ||
              (roles.includes('PUSH_INTERVIEW') &&
                tabName == 'interviewProcess')
            "
          >
            <b-button
              class="
                w-100
                d-flex
                align-items-center
                justify-content-center
                acs-addBtn-modal
              "
            >
              <img
                src="../../../assets/img/newworkbench/internalhiring/plusbtn.svg"
                alt=""
                class="mr-2"
              />
              <span>
                {{
                  tabName == "interviewProcess"
                    ? "Interview Process"
                    : "Feedback Form"
                }}
              </span>
            </b-button>
          </div>
        </div>
        <div
          class="
            newInt-footer
            d-flex
            align-items-center
            justify-content-end
            w-100
            bluebtn
          "
          style="padding: 15px 10px"
        >
          <b-button
            class="acs-cancelBtn-modal mr-3"
            :disabled="showButtonLoader"
            @click="closeModal"
            >Cancel</b-button
          >
          <div class="addpanellog position-relative">
            <b-button
              :class="showButtonLoader ? 'givefeed-loader-class' : 'pointer'"
              class="acs-addBtn-modal pl-4 pr-4"
              :disabled="isDisable || disableSave()"
              @click="!isDisable && !showButtonLoader ? saveFields() : ''"
            >
              <span v-if="!showButtonLoader"> Save </span>
            </b-button>
            <div v-if="showButtonLoader" class="loader-pos">
              <Loader />
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import InterviewProcessModal from "./InterviewProcessModal.vue";
import Loader from "../../../components/fixedcomponents/Loader.vue";

import FeedbackFormModal from "./FeedbackFormModal.vue";
import { mapGetters } from "vuex";
export default {
  name: "HiringProcessModal",
  props: {
    isFeedbackFormPresent: Boolean,
    showHiringModal: Boolean,
    tab: String,
    interviewProcessID: String,
    feedbackFormID: String,
  },
  components: {
    InterviewProcessModal,
    FeedbackFormModal,
    Loader,
  },
  data() {
    return {
      tabName: this.tab,
      showButtonLoader: false,
      isDisable: false,
      showSpinner: true,
      activeTab: 0,
      selectedInterview: {},
      selectedFeedbackForm: {},
    };
  },
  computed: {
    ...mapGetters(["roles"]),
    interviewProcessExists() {
      return (
        this.$refs.interviewProcessModal &&
        this.$refs.interviewProcessModal.selectedRound &&
        this.$refs.interviewProcessModal.selectedRound.interviewProcessID !==
          undefined
      );
    },
    feedbackFormExists() {
      return (
        this.$refs.feedbackFormModal &&
        this.$refs.feedbackFormModal.selectedFeedback &&
        this.$refs.feedbackFormModal.selectedFeedback.feedbackFormID !==
          undefined
      );
    },
  },
  methods: {
    disableSave() {
      return !(
        this.$refs.interviewProcessModal &&
        this.$refs.interviewProcessModal.selectedRound &&
        this.$refs.interviewProcessModal.selectedRound.interviewProcessID !==
          undefined &&
        this.$refs.feedbackFormModal &&
        this.$refs.feedbackFormModal.selectedFeedback &&
        this.$refs.feedbackFormModal.selectedFeedback.feedbackFormID !==
          undefined
      );
    },
    handleDisableSave(value) {
      this.isDisable = value;
    },
    async saveFields() {
      this.showButtonLoader = true;

      try {
        const { interviewProcessModal, feedbackFormModal } = this.$refs;

        if (interviewProcessModal.editRound) {
          await interviewProcessModal.editInterviewProcess();
          this.$emit("ip-selected", interviewProcessModal.selectedRound);
        } else if (feedbackFormModal.editSkill) {
          await feedbackFormModal.savefeedback();
          this.$emit("feedback-selected", feedbackFormModal.selectedFeedback);
        }
        if (
          interviewProcessModal.selectedRound.interviewProcessID &&
          this.interviewProcessID !==
            interviewProcessModal.selectedRound.interviewProcessID
        ) {
          this.$emit("ip-selected", interviewProcessModal.selectedRound);
        }
        if (
          feedbackFormModal.selectedFeedback.feedbackFormID &&
          this.feedbackFormID !==
            feedbackFormModal.selectedFeedback.feedbackFormID
        ) {
          this.$emit("feedback-selected", feedbackFormModal.selectedFeedback);
        }
      } catch (error) {
        console.error("Error saving fields:", error);
      } finally {
        this.showButtonLoader = false;
        this.closeModal();
      }
    },
    stopSpinner() {
      this.showSpinner = false;
    },
    changeTabName() {
      this.tabName = this.tab;
      this.tabName === "interviewProcess"
        ? (this.activeTab = 0)
        : (this.activeTab = 1);
    },
    goToHiring() {
      if (this.tabName == "interviewProcess") {
        this.$emit("createNewIP", "interviewProcess");
      } else if (this.tabName == "feedbackForm") {
        this.$emit("createNewIP", "feedbackForm");
      }
    },
    closeModal() {
      this.$emit("close-hiring-modal");
    },
  },
};
</script>

<style scoped>
.set-button {
  position: absolute;
  top: 20px;
  right: 30px;
}
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 87px;
}
</style>
